// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1JEIu","question":"Question_question__1WC5x","description":"Question_description__38w47"};